export enum AARoutePlannerEvents {
  PLAN_ROUTE = 'PlanRoute',
  ADD_VIA_ROUTE = 'AddViaRoute',
  REVERSE_ROUTE = 'ReverseRoute',
  UPDATE_SUMMARY = 'UpdateSummary',
  UPDATE_SIGNSPOTS = 'UpdateSignspots',
  UPDATE_SUMMARY_MATRIC = 'UpdateSummaryMatrics',
  DEDUCTED_CHANGES = 'DeductedChanges'
}

export enum GoogleMapEvents {
  CLICK = 'click',
  DRAG_END = 'dragend',
  ZOOM_CHANGED = 'zoom_changed',
  RIGHT_CLICK = 'rightclick',
  BOUNDS_CHANGED = 'bounds_changed',
  RESIZE = 'resize',
  IDLE = 'idle',
}

export enum AAGoogleMapEvents {
  MAP_READY = 'MapReady',
  UPDATE_MAP = 'UpdateMap',
  RESET_MAP = 'ResetMap',
  HIGHLIGHT_ROUTE = 'HighlightRoute',
  MOUSE_CLICKED = 'MouseClicked',
  MARKER_DRAG_END = 'MarkerDragEnd',

  ROUTE_LEG_HOVER = 'RouteLegHover',
  ROUTE_LEG_CLICK = 'RouteLegSelect',
  INVALID_ROUTE = 'InvalidRoute',
  VALID_ROUTE= 'ValidRoute'
}

export enum GoogleMapOptionsEvents {
  // MAP_OPTIONS_CHANGED = "MapOptionsChanged",
  CARPARK_CHANGED = 'CarParkChanged',
  TRAFFIC_ALERT_CHANGED = 'TrafficAlertChanged',
  TRAFFIC_ALERT_UPDATED = 'TrafficAlertUpdated',
  CLEAR_CLRSTER_DATA = 'ClearClesterData'
}

export enum HybridMapEvents {
  MAP_READY = 'HybridMapReady',
  UPDATE_MAP = 'HybridMapUpdate',
}

export enum AARouteEvents {
  ROUTE_READY = 'UrlRoutingReady',
  ROUTE_ACTIVATION_START = 'ActivationStart',
  ROUTE_CHANGED = 'AppRouteChanged',
}
export enum AAvoidTrafficEvents {
  UPDATE_TRAFFIC = 'updateTraffic'
}

export enum RouteValidationMessage {
  MAX_VIA_MESSAGE = 'maxViaMessage',
  VIA_MESSAGE = '',
  FROM_TO_MESSAGE = 'fromToMessage'
}

export enum breadcrumbsEvents {
  // TODO We are handing it through routing
  // CURRENT_MENU = "currentMenu"
}

export enum MapContextMenuEvents {
  // DIRECTIONS_FROM_HERE = "directionsFromHere",
  // DIRECTIONS_TO_HERE = "directionsToHere",
  // DIRECTIONS_VIA_HERE = "directionsViaHere",
  DIRECTIONS_CENTER_HERE = 'directionsCenterHere',
  ROUTE_DIRECTION_ERROR = 'routeDirectionError',
  ROUTE_VIA_DIRECTION_ERROR  = 'routeViaDirectionError',
  UPDATE_VIA_HERE = 'updateViaHere',

  UPDATE_TO_LOCATION = 'UpdateToLocation',
  UPDATE_FROM_LOCATION = 'UpdateFromLocation',
  UPDATE_VIA_LOCATION = 'UpdateViaLocation',
}

export enum AARoutePlannerAdvertisement {
  PLAN_ROUTE_ADVERTISEMENT = 'PlanRouteAdvertisement',
}


export enum RoutePlanerEventTracker {
  TAG_VIEW = 'TAG_VIEW',
  TAG_LINK = 'TAG_LINK'
}

export enum MobileNavigationEvent {
  MOBILE_MENU = 'mobile-menu',
  SELECT_MOBILE_MENU = 'select-mobile-menu'
}
